import { render } from "./elecBoardOfco2Head.vue?vue&type=template&id=d7162e64"
import script from "./elecBoardOfco2Head.vue?vue&type=script&lang=js"
export * from "./elecBoardOfco2Head.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__